export default __webpack_public_path__ + "static/media/Logo-invertrans-2.f9a8917a.png";